module.exports = __webpack_public_path__ + "img/no-pannic.3270ed09.svg";